import constants from 'common/constants';
import conversions from 'common/conversions';
import imageCompression from 'browser-image-compression';
import rules from 'common/validation-rules';

export default {
  Product: function () {
    this.id = -1;
    this.lineNo = -1;
    this.validationErrors = [];

    this.nameJa = {
      apiName: 'name_ja',
      csvName: '商品名',
      error: null,
      rule: [rules.required, rules.limitLength(50)],
      value: null,
    };
    this.productNo = {
      apiName: 'product_no',
      csvName: '商品番号',
      error: null,
      rule: [rules.required, rules.limitLength(50)],
      value: null,
    };
    this.colorJa = {
      apiName: 'color_ja',
      csvName: 'カラー',
      value: null,
      rule: [rules.limitLength(50)],
      error: null,
    };
    this.sizeJa = {
      apiName: 'size_ja',
      csvName: 'サイズ',
      error: null,
      rule: [rules.limitLength(50)],
      value: null,
    };
    this.description = {
      apiName: 'description',
      csvName: '詳細説明',
      error: null,
      rule: [rules.limitLength(500)],
      value: null,
    };
    this.listPrice = {
      apiName: 'list_price',
      csvName: '定価',
      error: null,
      rule: [rules.required, rules.numeric],
      value: null,
    };
    this.sellingPriceForItCenter = {
      apiName: 'selling_price_for_it_center',
      csvName: 'ＩＴセンター売価',
      error: null,
      rule: [rules.required, rules.numeric],
      value: null,
    };
    this.sellingPriceForDiveCenter = {
      apiName: 'selling_price_for_dive_center',
      csvName: 'ダイブセンター売価',
      error: null,
      rule: [rules.required, rules.numeric],
      value: null,
    };
    this.sellingPriceForMember = {
      apiName: 'selling_price_for_member',
      csvName: 'メンバー売価',
      error: null,
      rule: [rules.required, rules.numeric],
      value: null,
    };
    this.sellingPriceForPublic = {
      apiName: 'selling_price_for_public',
      csvName: '一般売価',
      error: null,
      rule: [rules.required, rules.numeric],
      value: null,
    };
    this.opening = {
      apiName: 'opening',
      csvName: '公開可否',
      error: null,
      rule: null,
      value: false,
    };
    this.displayableForItCenter = {
      apiName: 'displayable_for_it_center',
      csvName: 'ＩＴセンター表示可否',
      error: null,
      rule: null,
      value: false,
    };
    this.displayableForDiveCenter = {
      apiName: 'displayable_for_dive_center',
      csvName: 'ダイブセンター表示可否',
      error: null,
      rule: null,
      value: false,
    };
    this.displayableForMember = {
      apiName: 'displayable_for_member',
      csvName: 'メンバー表示可否',
      error: null,
      rule: null,
      value: false,
    };
    this.displayableForPublic = {
      apiName: 'displayable_for_public',
      csvName: '一般表示可否',
      error: null,
      rule: null,
      value: false,
    };
    this.carriageRequired = {
      apiName: 'carriage_required',
      csvName: '送料必要有無',
      error: null,
      rule: null,
      value: true,
    };
    this.productCategoryId = {
      apiName: 'product_category_id',
      csvName: '商品カテゴリID',
      error: null,
      rule: [rules.required, rules.numeric],
      value: null,
    };
    this.displayOrder = {
      apiName: 'display_order',
      csvName: '表示順',
      error: null,
      rule: [rules.required, rules.numeric],
      value: 100,
    };
    this.base64Images = {
      apiName: 'base64_images',
      csvName: null,
      error: null,
      rule: null,
      value: [],
    };
    this.thumbnailUrl = {
      apiName: 'thumbnail_file_name',
      csvName: null,
      error: null,
      rule: null,
      value: null,
    };
    this.imageUrls = {
      apiName: 'image_file_names',
      csvName: null,
      error: null,
      rule: null,
      value: [],
    };

    /**
     * 商品画像を生成する
     * @param {*} file 画像ファイル
     * @returns N/A
     */
    this.createProductImage = async function (file) {
      if (!file) return;
      try {
        // 画像ファイルを圧縮
        const compressedFile = await imageCompression(file, {
          maxSizeMB: 0.1, // 最大ファイルサイズ
          maxWidthOrHeight: 1024, // 最大画像幅もしくは高さ
        });
        let reader = new FileReader();
        // バイナリからbase64に変換
        reader.readAsDataURL(compressedFile);
        await new Promise((resolve) => (reader.onload = () => resolve()));
        const dataURI = reader.result;
        const base64 = dataURI.replace(/data:.*\/.*;base64,/, '');
        const timestamp = conversions.toDateString(new Date(), 'yyyyMMddHHmmssSSS');
        // base64Imageリストに追加
        if (this.base64Images.value) {
          this.base64Images.value.push({
            name: `${this.id.toString().padStart(6, '0')}_${timestamp}`, // ファイル名は仮設定
            base64Image: base64,
          });
        }
        // this.base64Images.value.forEach(function (element, index) {
        //   console.log(`index: ${index} file.name: ${file.name} -> element.name: ${element.name}`);
        // });
      } catch (error) {
        console.error(error);
      }
    };

    /**
     * CSVデータを取得する
     * @param {*} products 商品リスト
     * @param {*} withHeader ヘッダー有無
     */
    this.getCsv = function (products, withHeader) {
      const separator = ',';

      //ファイルの先頭にBOMとして'\ufeff'を追加し、WindowsのExcelでUTF8の識別ができるようにする
      let csv = '\ufeff';

      // ヘッダー部分
      let header = `ID`;
      Object.keys(this).forEach((key) => {
        if (typeof this[key] !== 'function' && this[key].csvName) {
          header += `${separator}${this[key].csvName}`;
        }
      });
      header += '\n';
      if (withHeader) csv += header;

      // データ部分
      products.forEach((product) => {
        let line = `${product.id}`;
        Object.keys(product).forEach((key) => {
          if (typeof product[key] !== 'function' && product[key].csvName) {
            switch (key) {
              case 'description':
                line += `${separator}"${product[key].value ? product[key].value : ''}"`;
                break;
              case 'opening':
              case 'displayableForItCenter':
              case 'displayableForDiveCenter':
              case 'displayableForMember':
              case 'displayableForPublic':
              case 'carriageRequired':
                line += `${separator}${product[key].value ? '1' : '0'}`;
                break;
              default:
                line += `${separator}${
                  product[key].value || product[key].value === 0 ? product[key].value : ''
                }`;
            }
          }
        });
        line += '\n';
        csv += line;
      });
      return csv;
    };

    /**
     * API登録時に使用するリクエストボディを取得する
     * @returns リクエストボディ
     */
    this.getRequestBody = function () {
      let product = {};
      Object.keys(this).forEach((key) => {
        if (typeof this[key] !== 'function' && this[key].apiName) {
          switch (this[key].apiName) {
            case 'base64_images':
              let base64Images = [];
              this[key].value.forEach(function (image) {
                base64Images.push({
                  name: image.name,
                  base64_image: image.base64Image,
                });
              });
              product['product_base64_images'] = base64Images;
              break;
            case 'thumbnail_file_name':
            case 'image_file_names':
              break;
            default:
              product[this[key].apiName] = this[key].value;
          }
        }
      });
      let body = { product: product };
      // console.log(`body: ${JSON.stringify(body)}`);
      return body;
    };

    /**
     * 商品画像を削除する
     * @param {*} name 画像ファイル名
     * @returns
     */
    this.removeProductImage = function (name) {
      if (!name || !this.base64Images.value) return;
      this.base64Images.value = this.base64Images.value.filter((image) => {
        return image.name !== name;
      });
    };

    /**
     * APIから取得したデータをセットする
     * @param {*} api APIから取得した商品情報
     */
    this.setApiData = function (api) {
      if (!api) return;
      this.id = api['id'];
      Object.keys(this).forEach((key) => {
        if (typeof this[key] !== 'function' && this[key].apiName) {
          switch (this[key].apiName) {
            case 'base64_images':
              let images = [];
              if (api[this[key].apiName]) {
                api[this[key].apiName].forEach(function (image) {
                  images.push({
                    name: image.name,
                    base64Image: image.base64_image,
                  });
                });
              }
              this[key].value = images;
              break;
            case 'thumbnail_file_name':
              this[
                key
              ].value = `${constants.SHOPPING_API_URL}/product_images/${api['thumbnail_file_name']}`;
              break;
            case 'image_file_names':
              let names = [];
              if (api[this[key].apiName]) {
                api[this[key].apiName].forEach(function (fileName) {
                  names.push(`${constants.SHOPPING_API_URL}/product_images/${fileName}`);
                });
              }
              this[key].value = names;
              break;
            default:
              if (
                api[this[key].apiName] ||
                api[this[key].apiName] === 0 ||
                api[this[key].apiName] === false
              )
                this[key].value = api[this[key].apiName];
          }
        }
      });
      // console.debug(`this: ${JSON.stringify(this)}`);
    };

    /**
     * CSVから取得したデータをセットする
     * @param {*} csv CSVから取得した商品情報
     * @param {*} lineNo 行No
     */
    this.setCsvData = function (csv, lineNo) {
      if (!csv) return;

      this.id = csv['ID'] ? csv['ID'] : -1;
      if (lineNo) this.lineNo = lineNo;

      Object.keys(this).forEach((key) => {
        if (typeof this[key] !== 'function' && this[key].csvName) {
          this[key].value = csv[this[key].csvName];
          // CSVデータの検証
          if (this[key].rule) {
            let results = rules.validate(this[key].value, this[key].rule, this[key].csvName);
            if (this.validationErrors && results.length > 0) this.validationErrors.push(results);
          }
        }
      });

      // API側でN/Aの文字列がある場合は画像の差し替えを行わない
      this.base64Images.value = [
        {
          name: constants.IMAGE_SKIP_VALUE,
          base64Image: null,
        },
      ];

      // console.log(`this: ${JSON.stringify(this)}`);
    };
  },
};
